import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, HeadingText, Button } from '@paypalcorp/pp-react';
import classNames from 'classnames';
import { chatBotIcon } from '../../lib/svgImages';
import { bannerColors } from '../commonConstants';

const CustomChatBotContainer = (props) => {
  const { banner, chatBotonClickButtonHandler, headingLabel, descriptionLabel, buttonLabel } = props;

  // Get container class names based on the banner through props.
  const handleChatBotCardClassName = () =>
    classNames({
      'customChatBot-Container': banner === bannerColors.BLUE_BANNER,
      'whiteChatBot-Container': banner === bannerColors.WHITE_BANNER,
    });

  const handleChatBotButtonClassName = () =>
    classNames({
      'customChatBot-Button': banner === bannerColors.BLUE_BANNER,
      'whiteChatBot-Button': banner === bannerColors.WHITE_BANNER,
    });

  const handleChatBotHeadingClassName = () =>
    classNames({
      'customChatBot-header-label': banner === bannerColors.BLUE_BANNER,
      'whiteChatBot-header-label': banner === bannerColors.WHITE_BANNER,
    });

  const handleChatBotIconClassName = () =>
    classNames({
      'whiteChatBot-icon': banner === bannerColors.WHITE_BANNER,
    });

  const handleChatBotDescriptionClassName = () =>
    classNames({
      'whiteChatBot-description': banner === bannerColors.WHITE_BANNER,
    });

  // Rendering White or Blue ChatBot container based on the props 'banner'
  const rendercustomChatBotContainer = () => (
    <Container className={handleChatBotCardClassName()} id="custom-chat-container">
      <Row>
        {banner === bannerColors.WHITE_BANNER && (
          <Col md="auto">
            <div className={handleChatBotIconClassName()}>{chatBotIcon}</div>
          </Col>
        )}
        <Col>
          <div className={handleChatBotHeadingClassName()}>
            <HeadingText size="md">{headingLabel}</HeadingText>
          </div>
          <div className={handleChatBotDescriptionClassName()}>
            <span>{descriptionLabel}</span>
          </div>
        </Col>
        <Col md="auto">
          <Button
            className={handleChatBotButtonClassName()}
            secondary
            inverse={banner !== bannerColors.WHITE_BANNER}
            // eslint-disable-next-line react/jsx-no-bind
            onClick={(e) => chatBotonClickButtonHandler(e)}
          >
            {buttonLabel}
          </Button>
        </Col>
      </Row>
    </Container>
  );
  return rendercustomChatBotContainer();
};

CustomChatBotContainer.prototype = {
  banner: PropTypes.string.isRequired,
  headingLabel: PropTypes.string,
  descriptionLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  chatBotonClickButtonHandler: PropTypes.fun,
};

export default React.memo(CustomChatBotContainer);
